import { Avatar } from 'src/components/Avatar';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

import { CheckinBlockerUser } from './_types';

export function UserDetails({ user }: { user: CheckinBlockerUser }) {
  return (
    <Stack alignItems="center" spacing={1} sx={{ width: '100%' }}>
      <Avatar alt={user.name ?? ''} size="xlarge" src={user.profileImage} />
      <Typography
        sx={{
          color: 'text.primary',
          fontSize: 21,
          fontWeight: 400,
          lineHeight: '28px',
          textAlign: 'center',
          width: '100%',
        }}
      >
        {user.name ?? ''}
      </Typography>
    </Stack>
  );
}
